import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { map } from 'rxjs/operators';
import { toArray } from 'lodash';
import { HistoryData } from "./history";
import { TrackingProvider, _TRACKING_ENTITIES } from "./tracking";

@Injectable()
export class CommercialSampleData {
  constructor(
    private historyData: HistoryData,
    private tracking: TrackingProvider,
    private afDb: AngularFireDatabase
  ) { }

  public getEventCommercialSampleList(clientId: string, id: string): Observable<any[]> {
    return this.afDb
      .list(`Clients/${clientId}/Events/${id}/CommercialSamples`)
      .valueChanges()
      .pipe(
        map((data: any) => {
          data.map((item) => {
            item.categories = toArray(item.categories);
          });
          return data;
        })
      );
  }

  public saveClientCommercialSample(clientId: string, sample: any) {
    if (sample.id === "") {
      sample.id = this.afDb.createPushId();
    }
    return this.afDb.object(`Clients/${clientId}/CommercialSamples/${sample.id}`)
      .update(sample)
      .then((() =>
        this.historyData.set(
          `Module client commercial sample content`,
          "commercial_sample",
          "update",
          sample
        )
      ))
      .then(() => {
        this.tracking.trackEntity(_TRACKING_ENTITIES.COMMERCIAL_SAMPLE, sample.id, clientId, sample)
      })
  }

  public getClientCommercialSampleList(clientId: string) {
    return this.afDb.list(`Clients/${clientId}/CommercialSamples`).valueChanges();
  }

  public getClientCommercialSampleListById(clientId: string, sampleId) {
    return this.afDb.object(`Clients/${clientId}/CommercialSamples/${sampleId}`).valueChanges();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/commercial-sample.ts